export default "__VITE_ASSET__gGYU7zgw__"